// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6d2b7e36","703":"528963f8","787":"5621cbab"}[chunkId] + ".chunk.js";
};